import React, { useEffect, useState } from 'react'
import HeaderBar from '../HeaderBar';
import SideDrawer from '../SideDrawer/SideDrawer';
import { Box } from '@mui/material';
import ActionBar from '../actionBar';
import ReportDashboard from '../ReportDashBoard';
import Dashboard from '../DashBoard';
import LeadsDashboard from '../leadsDashboard';
import WORKersDashboard from '../WORKersManagement/WORKersDashboard/WORKersDashboard';
import ChaptersManagement from '../chaptersManagement/ChaptersManagement';
import ChapterLeads from '../ChapterLeads/ChapterLeads';
import PollTemplateScreen from '../AttendancePoll/TemplatePage/PollTemplateScreen';
import TaskDashboard from '../Tasks/TaskDashboard/TaskDashboard';
import TrainingProgram from '../Training/Program/TrainingProgram';
import RegistrationHub from '../RegistrationHub/RegistrationHub';
import CommitteeDashboard from '../Commitees/CommitteeDashboard';
import Courses from '../CoursesManagement/Courses';

const LandingPage = () => {

	const [selectedDashBoard, setSelectedDashboard] =useState(
		((localStorage.getItem('designation') && localStorage.getItem('designation') === 'admin') || 
		localStorage.getItem('isStateHead') === 'true' || 
		localStorage.getItem('isDistrictHead') === 'true' ?
		"WORKers" : "Daily Task"
	));

	const updateSelectedDashboard = (dashboard) => {
		setSelectedDashboard(dashboard)
	}

  
  return (
    <>
			<HeaderBar></HeaderBar>
			<Box style={{display: 'flex', flexDirection: 'row'}}>
				<SideDrawer 
					selectedDashboard = {selectedDashBoard}
					updateSelectedDashboard={updateSelectedDashboard}>
				</SideDrawer>
				<Box style={{width: '100%', display: 'flex', flexDirection: 'column', height: '91vh'}}>
					{/* <ActionBar></ActionBar> */}
					{
							selectedDashBoard === 'One Time Task' ? 
							<ReportDashboard subDashboard= {'One Time Task'}></ReportDashboard> :
							selectedDashBoard === 'Daily Task' ? 
							<ReportDashboard subDashboard= {'Daily Task'}></ReportDashboard> :
							selectedDashBoard === 'Weekly Task' ? 
							<ReportDashboard subDashboard= {'Weekly Task'}></ReportDashboard> :
							selectedDashBoard === 'Monthly Task' ? 
							<ReportDashboard subDashboard= {'Monthly Task'}></ReportDashboard> :
							selectedDashBoard === 'Members' ? 
							<Dashboard></Dashboard> : 
							selectedDashBoard === 'Leads' ? 
							<LeadsDashboard></LeadsDashboard> :
							selectedDashBoard === 'chapterLeads' ? 
							<ChapterLeads></ChapterLeads> :
							selectedDashBoard === 'WORKers' ?
							<WORKersDashboard></WORKersDashboard> :
							selectedDashBoard === 'Chapters' ?
							<ChaptersManagement></ChaptersManagement>: 
							selectedDashBoard === 'pollTemplates' ?
							<PollTemplateScreen></PollTemplateScreen> :
							selectedDashBoard === 'task' ? 
							<TaskDashboard></TaskDashboard> :
							selectedDashBoard === 'training' ?
							<TrainingProgram></TrainingProgram>: 
							selectedDashBoard === 'courses' ?
							<Courses></Courses> :
							selectedDashBoard === 'registrationHub' ?
							<RegistrationHub></RegistrationHub> :
							// selectedDashBoard === 'committees' ?
							// <CommitteeDashboard></CommitteeDashboard> :
					<></>
					}
				</Box>

			</Box>
		</>
  )
}

export default LandingPage
